export default {
  CONTACT_PANEL: {
    NEW_TASK: 'Новая задача',
    TASK_ALREADY_CREATED: 'Задача уже создана',
    NEW_TASK_ERROR: 'Не удалось создать задачу. Попробуйте ещё раз.',
  },
};
